import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./_homeItemsGalleryComponent.scss";
import HomeItemGalleryCard from "./itemCard/HomeItemGalleryCard";

const HomeItemsGalleryComponent = ({ title, items }) => {
  if (!items) return;

  return (
    <div className="homeItemsGalleryContainer">
      {title && <h2 className="homeItemsGalleryTitle">{title}</h2>}
      <Swiper
        spaceBetween={30}
        slidesPerView={5}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        // navigation={true}
        modules={[Navigation, Autoplay, Pagination]}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
        }}>
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <HomeItemGalleryCard product={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeItemsGalleryComponent;
